import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import PropTypes from 'prop-types';
import DateEditor from './DateEditor';
import DateFormatter from './DateFormatter';
import {
  dateFilterEquals,
  dateFilterGreaterThan,
  dateFilterLessThan,
  dateFilterMonthEquals,
  dateFilterYearEquals,
} from '@ozgene/gp5.utils.filter-functions';
import ContextualDateFormatter from './ContextualDateFormatter';

export const getDatePredicate = (value, filter) =>
  filter.operation === 'before'
    ? dateFilterLessThan(value, filter.value)
    : filter.operation === 'after'
    ? dateFilterGreaterThan(value, filter.value)
    : filter.operation === 'month'
    ? dateFilterMonthEquals(value, filter.value)
    : filter.operation === 'year'
    ? dateFilterYearEquals(value, filter.value)
    : dateFilterEquals(value, filter.value);

export function DateProvider (props) {
  const { availableFilterOperations, useChip, ...restProps } = props;
  const allFilterOperations = [
    'dateEquals',
    'before',
    'after',
    'year',
    'month',
  ];

  return (
    <DataTypeProvider
      availableFilterOperations={
        availableFilterOperations.length
          ? availableFilterOperations
          : allFilterOperations
      }
      formatterComponent={useChip ? ContextualDateFormatter : DateFormatter}
      editorComponent={DateEditor}
      {...restProps}
    />
  );
};

DateProvider.propTypes = {
  availableFilterOperations: PropTypes.arrayOf(PropTypes.string),
  useChip: PropTypes.bool,
};

DateProvider.defaultProps = {
  availableFilterOperations: [],
  useChip: false,
};
